const firebaseConfig = {
  apiKey: "AIzaSyDXFwxO4NUUuNv2kTPvRSPHIvpb3BshZR8",
  authDomain: "interior-design-service.firebaseapp.com",
  projectId: "interior-design-service",
  storageBucket: "interior-design-service.appspot.com",
  messagingSenderId: "178321530411",
  appId: "1:178321530411:web:fd70607a8d03ac2e24146e",
};
export default firebaseConfig;